import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'CONTACT_SETTINGS_VIEW', {
  TITLE: 'Contact Settings',
  DESCRIPTION:
    'Configure the WhatsApp number that will be displayed to clients for inquiries about their procedures.',
  WHATSAPP_LABEL: 'WhatsApp Number:',
  HELPER_TEXT: 'Include the country code and area code (without the 15).',
  SUBMIT_BUTTON: 'Save',
  CONTACT_TITLE: 'Contact Settings',
  LOADING: 'Loading...',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'CONTACT_SETTINGS_VIEW', {
  TITLE: 'Configuración de Contacto',
  DESCRIPTION:
    'Configure el número de WhatsApp que verán los clientes para realizar consultas sobre sus trámites.',
  WHATSAPP_LABEL: 'Número de WhatsApp:',
  HELPER_TEXT: 'Incluir código de país y área (sin el 15).',
  SUBMIT_BUTTON: 'Guardar',
  LOADING: 'Cargando...',
});
